import React from "react"
import firebase from "firebase/app"
import { PaymentRequestButtonElement } from "@stripe/react-stripe-js"
import { Button, Modal } from "reactstrap"

const ModalComponent = ({
  showModal, // Toggling Modal From Parent Component
  toggleModal, // Toggling Modal From Parent Component
  orderData,
  handlePaymentSubmit, // Handling Payment Submission In Parent
  elements, // Offical Stripe Component
  stripe, // Offical Stripe Component
  paymentRequest, // For PaymentRequestButtonElement
  checkoutMethodTitle, // Depends On Payment Method Selection - Card Or Pay Now
}) => {
  const {
    orderDate,
    orderTime,
    firstName,
    lastName,
    phone,
    email,
    addressLine1,
    addressLine2,
    city,
    zipCode,
    finalCost,
  } = orderData
  return (
    <Modal
      size="sm"
      className="modal-dialog-centered"
      isOpen={showModal}
      toggle={() => toggleModal()}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-default">
          Order Summary
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => toggleModal()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <b>Order Date:</b> {orderDate ? orderDate.toDateString() : ""}
        <br />
        <b>Order Time:</b> {orderTime}
        <br />
        <b>Name:</b> {firstName + " " + lastName}
        <br />
        <b>Phone:</b> {phone}
        <br />
        <b>Email:</b> {email}
        <br />
        <b>Address:</b>{" "}
        {`${addressLine1}, ${
          addressLine2 ? addressLine2 + ", " : ""
        }${city}, ${zipCode}`}
        <br />
        <b>Total Cost:</b> {`$${finalCost}`}
      </div>
      <div className="modal-footer">
        {paymentRequest &&
        checkoutMethodTitle === "stripe-payment-request-button-payment" ? (
          <PaymentRequestButtonElement
            options={{
              paymentRequest,
            }}
          />
        ) : (
          <Button
            color="success"
            type="button"
            onClick={() => {
              handlePaymentSubmit(elements, stripe)
              firebase.analytics().logEvent("payment_tried")
              toggleModal()
            }}
          >
            Confirm
          </Button>
        )}
        <Button
          className="ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={() => toggleModal()}
        >
          Close
        </Button>
      </div>
    </Modal>
  )
}

export default ModalComponent
